const Dashboard = () => {
  return <>Hi</>;
};

export default Dashboard;
